import { Paper, SimpleGrid, Stack, Text } from "@mantine/core";
import type { AssistantStyleText } from "@/locales/assistant-style";
import type { StylePreset } from "@/types/ai-assistant-style";
import { buildStylePreview } from "./style-settings.logic";

interface Props {
	t: AssistantStyleText;
	lang: "id" | "en";
	chatStyle: StylePreset;
	voiceStyle: StylePreset;
	words: readonly string[];
}

/** Pratinjau langsung dari template lokal — tidak memanggil AI. */
export function StylePreview({ t, lang, chatStyle, voiceStyle, words }: Props) {
	const items = [
		{ key: "chat", label: t.preview.chat, preset: chatStyle },
		{ key: "voice", label: t.preview.voice, preset: voiceStyle },
	] as const;
	return (
		<Stack gap={6}>
			<Text fw={600} size="sm">
				{t.preview.title}
			</Text>
			<Text size="xs" c="dimmed">
				{t.preview.description}
			</Text>
			<SimpleGrid cols={{ base: 1, sm: 2 }}>
				{items.map((item) => (
					<Paper key={item.key} withBorder radius="md" p="sm">
						<Text size="xs" c="dimmed" mb={4}>
							{item.label} · {t.styles.presets[item.preset]}
						</Text>
						<Text size="sm" data-style-preview={item.key}>
							{buildStylePreview(item.preset, words, lang)}
						</Text>
					</Paper>
				))}
			</SimpleGrid>
		</Stack>
	);
}
